// Entry point for the build script in your package.json
import "./controllers";
import * as bootstrap from "bootstrap";
import { updateBackToTopVisibility } from "./back_to_top";

window.bootstrap = bootstrap;

document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("scroll", updateBackToTopVisibility, { passive: true })
  updateBackToTopVisibility()
})
